export default __webpack_public_path__ + "90fdace76cb71c6ae631795bc357d5c1.svg";